export const base64ToBlob = (base64: string) => {
  const base64Data = base64.split(',')[1]; // Remove the prefix 'data:image/jpeg;base64,'
  const byteCharacters = atob(base64Data);
  const byteArrays: Uint8Array[] = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);

    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  // Cast para BlobPart[] para resolver o erro de tipo
  return new Blob(byteArrays as BlobPart[], { type: 'image/jpeg' });
};
